module.exports = __webpack_public_path__ + "static/media/truck.aa1d541d.svg";